import { IAdSettingsFormValues } from '@/editor/shared/components/forms/ad-settings/AdSettingsForm';
import { getValueFromLs } from '@/shared/services/localstorage';
import { EDITOR_LS_CONSTANTS } from '@/editor/shared/constants/editor-LS.constants';
import { useAppDispatch } from '@/store/hooks/redux';
import { setPropertyAddress } from '@/editor/store/reducers/property-info.slice';
import { useEffect } from 'react';

// note
// this can be a place to restore whole ad set and creative state in the future
// to remove restoring in components, just fetch data from LS here and put it to states
// then just select data on entrance to component

export const useRestoreDataFromLocalStorage = () => {
  const dispatch = useAppDispatch();

  const AdsetFormValues: IAdSettingsFormValues = JSON.parse(
    (getValueFromLs(EDITOR_LS_CONSTANTS.ADSET_FORM) as string) ?? null
  );

  const propertyAddress = getValueFromLs(EDITOR_LS_CONSTANTS.PROPERTY_ADDRESS) as string;

  useEffect(() => {
    if (propertyAddress) {
      dispatch(setPropertyAddress(propertyAddress));
    }
  }, [propertyAddress]);
};
